import { render, staticRenderFns } from "./Chartone.vue?vue&type=template&id=4960b0f4"
import script from "./Chartone.vue?vue&type=script&lang=js"
export * from "./Chartone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports